module.exports = "/packs/shares-4930420-f22c65b07893a96dafeb4813d6377517.png";